class EmulatedStorage implements Storage {
  private readonly _storage: Map<string, string> = new Map()

  get length(): number {
    return this._storage.size
  }

  clear(): void {
    this._storage.clear()
  }

  getItem(key: string): string | null {
    return this._storage.get(key) || null;
  }

  key(index: number): string | null {
    throw new Error("key is unsupported")
  }

  removeItem(key: string): void {
    this._storage.delete(key)
  }

  setItem(key: string, value: string): void {
    this._storage.set(key, value)
  }
}

const ConsentStorageKey = "tickaroo-embedconsent"

export function createConsentStorage(): Storage {
  return (typeof window === 'undefined') ? new EmulatedStorage() : (window.localStorage || new EmulatedStorage())
}

// null-prototype so provider names like "__proto__" behave as plain keys
// instead of hitting Object.prototype (which would silently drop the write
// and make getConsent return a truthy value for a never-granted provider)
export function createConsentMap(entries?: Record<string, boolean | undefined>): Record<string, boolean | undefined> {
  return Object.assign(Object.create(null), entries)
}

export function readStoredConsentMap(storage: Storage): Record<string, boolean | undefined> {
  try {
    const json = storage.getItem(ConsentStorageKey)
    if (json) {
      return createConsentMap(JSON.parse(json))
    }
  } catch (e) {
    //ignore
  }
  return createConsentMap()
}

export function writeStoredConsentMap(storage: Storage, consentMap: Record<string, boolean | undefined>): void {
  try {
    storage.setItem(ConsentStorageKey, JSON.stringify(consentMap))
  } catch (e) {
    //ignore
  }
}

// read-modify-write per key so concurrent providers (multiple widgets on one
// page) don't overwrite each other's decisions with their own stale snapshot
export function updateStoredConsent(storage: Storage, provider: string, consent: boolean): void {
  const stored = readStoredConsentMap(storage)
  stored[provider] = consent
  writeStoredConsentMap(storage, stored)
}
